export const customStyles = {
    providerFilter: {
        container: (provided) => ({
            display: "inline-block",
            position: "relative",
            width: "100%",
            borderRadius: "4px",
            ...provided
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: "40px",
            borderColor: "#ad728b",
            boxShadow: state.isFocused ? 0 : 0,
            "&:hover": {
                borderWidth: "2px",
                borderColor: "#ad728b"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontWeight: 500,
            color: state.isSelected ? "#fff" : "#ad728b",
            background: state.isSelected ? "#ad728b" : "#fff",
            fontSize: "1rem",
            fontFamily: "Poppins",
            textAlign: "center",
            "&:hover": {
                background: "#f0d3df"
            }
        })
    }
};
